import FullscreenSpinner from 'components/FullscreenSpinner'
import useFetch from 'hooks/useFetch'
import { API_URL } from 'myconstant'
import AdminLayout from 'pages/components/admin/AdminLayout'
import React, { useCallback, useRef, useState } from 'react'
import { ClipLoader } from 'react-spinners'
import '@toast-ui/editor/dist/toastui-editor.css'
import { Editor } from '@toast-ui/react-editor'
import { Breadcrumb, Button, Input, notification, Select, Table, Upload } from 'antd'
import { useEffect } from 'react'
import axios from 'axios'
import { addQueryParameter } from 'utils'
import date from 'date-and-time'
import styles from './BoardWrite.module.scss'

import fontSize from 'tui-editor-plugin-font-size'
import 'tui-editor-plugin-font-size/dist/tui-editor-plugin-font-size.css'

import colorSyntax from '@toast-ui/editor-plugin-color-syntax'
import 'tui-color-picker/dist/tui-color-picker.css'
import '@toast-ui/editor-plugin-color-syntax/dist/toastui-editor-plugin-color-syntax.css'

import { useLocation, useNavigate } from 'react-router-dom'
import { UploadOutlined } from '@ant-design/icons'

const InsightWrite = () => {
  const { state } = useLocation()
  const {
    id = null,
    title: pTitle = null,
    content: pContent = null,
    image = null,
  } = state ? state : {}

  const baseUrl = '/api/insight'
  const [title, setTitle] = useState(pTitle || '')
  const [fileList, setFileList] = useState([])
  const editorRef = useRef()
  const navigate = useNavigate()
  const [originalImgPath, setOriginalImgPath] = useState(image)
  useEffect(() => {
    if (id && pContent) {
      editorRef.current?.getInstance().setHTML(pContent)
    }
  }, [])

  const getFormData = (content) => {
    const formData = new FormData()

    formData.append(
      'file',
      fileList?.map?.(file => file.originFileObj)
    )
    formData.append('originalImgPath', originalImgPath)
    formData.append('title', title)
    formData.append('content', content)
    return formData
  }

  const save = () => {
    const content = editorRef.current?.getInstance().getHTML()
    if (!title || !content || content === '<p><br></p>') {
      notification.error({
        message: '제목과 내용이 모두 입력되어야 합니다.',
        placement: 'bottom',
        duration: 2,
      })
      return
    }
    const formData = getFormData(content)

    axios
      .post(baseUrl, formData, {
        header: { 'content-type': 'multipart/form-data' },
      })
      .then((res) => {
        notification.info({
          message: '저장되었습니다.',
          placement: 'bottom',
          duration: 2,
        })
        navigate('/admin/insight')
      })
      .catch((e) => {
        notification.error({
          message: e.response?.data || e.message,
          placement: 'bottom',
          duration: 2,
        })
      })
  }

  const onChange = ({ fileList: newFileList }) => {
    setFileList([newFileList])
  }

  const modifyContent = () => {
    const content = editorRef.current?.getInstance().getHTML()
    if (!title || !content || content === '<p><br></p>') {
      notification.error({
        message: '제목과 내용이 모두 입력되어야 합니다.',
        placement: 'bottom',
        duration: 2,
      })
      return
    }
    const formData = getFormData(content)

    if (confirm('수정 전 내용은 복원되지 않습니다. 수정하시겠습니까?')) {
      axios
        .patch(`${baseUrl}/${id}`, formData, {
          header: { 'content-type': 'multipart/form-data' },
        })
        .then((res) => {
          notification.info({
            message: '수정되었습니다.',
            placement: 'bottom',
            duration: 2,
          })
          navigate('/admin/insight')
        })
        .catch((e) => {
          debugger
          notification.error({
            message: e.response?.data || e.message,
            placement: 'bottom',
            duration: 2,
          })
        })
    }
  }

  const deleteContent = () => {
    if (confirm('삭제하시겠습니까? 삭제된 내용은 복원되지 않습니다')) {
      axios
        .delete(`${baseUrl}/${id}`)
        .then((res) => {
          notification.info({
            message: '삭제되었습니다.',
            placement: 'bottom',
            duration: 2,
          })
          navigate('/admin/insight')
        })
        .catch((e) => {
          debugger
          notification.error({
            message: e.response?.data || e.message,
            placement: 'bottom',
            duration: 2,
          })
        })
    }
  }

  return (
    <AdminLayout>
      <Breadcrumb style={{ margin: '16px 0' }}>
        <Breadcrumb.Item>Story</Breadcrumb.Item>
        <Breadcrumb.Item>탐구생활</Breadcrumb.Item>
        <Breadcrumb.Item>{id && pContent ? '수정' : '작성'}</Breadcrumb.Item>
      </Breadcrumb>
      <section className={styles['button-area']}>
        <Input
          addonBefore="제목"
          onChange={(e) => setTitle(e.target.value)}
          value={title}
          style={{ marginBottom: '10px' }}
        />
      </section>
      <div style={{ marginTop: '20px', marginBottom: '20px' }}>
        <div>
          {originalImgPath ? (
            <>
              {originalImgPath}
              <Button
                style={{ marginLeft: '10px' }}
                onClick={() => setOriginalImgPath('deleted')}
              >
                이미지삭제
              </Button>
            </>
          ) : null}
        </div>
        {/* <Upload onChange={onChange} fileList={fileList} action={'/api/file/upload'}> */}
        <Upload onChange={onChange} action={'/api/file/upload?table_name=insight'}>
          <Button icon={<UploadOutlined />}>Click to Upload</Button>
        </Upload>
      </div>
      <Editor
        ref={editorRef}
        previewStyle="vertical"
        height="600px"
        initialEditType="wysiwyg"
        useCommandShortcut={true}
        plugins={[fontSize, colorSyntax]}
        toolbarItems={[
          // ['heading'],
          [],
          ['bold', 'strike', 'link'],
          // ['hr', 'table', 'link'],
          // ['ul', 'task', 'indent', 'outdent'],
        ]}
      />
      <section className={styles['button-area']}>
        {id ? (
          <>
            <Button type="primary" onClick={modifyContent}>
              수정
            </Button>
            <Button
              type="primary"
              onClick={deleteContent}
              style={{ marginLeft: '5px' }}
            >
              삭제
            </Button>
          </>
        ) : (
          <Button type="primary" onClick={save}>
            글쓰기
          </Button>
        )}
      </section>
    </AdminLayout>
  )
}

export default InsightWrite
